module.exports = __webpack_public_path__ + "img/plant-ar.44457a8e.jpg";